var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRoundedChevronDown = function SvgRoundedChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 7,
    width: 11,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1 5.5 5 1 1",
    stroke: "var(--native-icon-fill)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
};

export default SvgRoundedChevronDown;